
function playVideo(sectionId) {
  const wrapper = document.getElementById('video-wrapper-' + sectionId);
  const iframe = document.getElementById('video-iframe-' + sectionId);
  
  // Add playing class to hide overlay and thumbnail
  wrapper.classList.add('playing');
  
  // Auto-play the video by updating the src with autoplay parameter
  const currentSrc = iframe.src;
  if (currentSrc.includes('youtube.com/embed/')) {
    iframe.src = currentSrc + '&autoplay=1';
  } else if (currentSrc.includes('vimeo.com')) {
    iframe.src = currentSrc + '&autoplay=1';
  }
}

function playUploadedVideo(sectionId) {
  const wrapper = document.getElementById('video-wrapper-' + sectionId);
  const video = document.getElementById('uploaded-video-' + sectionId);
  
  // Add playing class to hide overlay and thumbnail
  wrapper.classList.add('playing');
  
  // Play the uploaded video
  if (video) {
    video.play();
    
    // Add event listeners to show/hide play button based on video state
    video.addEventListener('pause', function() {
      wrapper.classList.remove('playing');
    });
    
    video.addEventListener('ended', function() {
      wrapper.classList.remove('playing');
    });
    
    // Hide overlay when video is playing
    video.addEventListener('play', function() {
      wrapper.classList.add('playing');
    });
  }
}

// Alternative function for toggling play/pause
function toggleVideoPlay(sectionId) {
  const wrapper = document.getElementById('video-wrapper-' + sectionId);
  const video = document.getElementById('uploaded-video-' + sectionId);
  
  if (video) {
    if (video.paused) {
      wrapper.classList.add('playing');
      video.play();
    } else {
      video.pause();
      wrapper.classList.remove('playing');
    }
  }
}
